import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiCalendar, FiPhone, FiFileText, FiSettings } = FiIcons;

const MentorshipSection = () => {
  return (
    <section className="mentorship-section py-20 px-4 bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            How We <span className="text-yellow-400">Work Together</span>
          </h2>
        </motion.div>

        <motion.div 
          className="mentorship-format bg-white/10 backdrop-blur-lg p-8 rounded-2xl border border-white/20 mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-8">
            <SafeIcon icon={FiUser} className="text-5xl text-yellow-400 mx-auto mb-4" />
            <h3 className="text-3xl font-bold mb-4">1-to-1 Personal Mentorship with Abdul</h3>
            <div className="bg-red-500/20 border border-red-500/50 p-4 rounded-lg inline-block">
              <p className="text-red-300 font-semibold">
                Limited to 5 people per month – currently 1 taken, 4 left
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <motion.div 
              className="feature-card bg-white/5 p-6 rounded-xl border border-white/10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiCalendar} className="text-3xl text-blue-400 mb-4" />
              <h4 className="font-bold text-lg mb-2">Daily Action Steps</h4>
              <p className="text-gray-300 text-sm">Clear, actionable tasks for all 7 days</p>
            </motion.div>

            <motion.div 
              className="feature-card bg-white/5 p-6 rounded-xl border border-white/10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiSettings} className="text-3xl text-green-400 mb-4" />
              <h4 className="font-bold text-lg mb-2">Implementation Support</h4>
              <p className="text-gray-300 text-sm">Abdul's team helps you implement</p>
            </motion.div>

            <motion.div 
              className="feature-card bg-white/5 p-6 rounded-xl border border-white/10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiPhone} className="text-3xl text-purple-400 mb-4" />
              <h4 className="font-bold text-lg mb-2">Unlimited 1-to-1 Calls</h4>
              <p className="text-gray-300 text-sm">For the rest of the month after launch</p>
            </motion.div>

            <motion.div 
              className="feature-card bg-white/5 p-6 rounded-xl border border-white/10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <SafeIcon icon={FiFileText} className="text-3xl text-yellow-400 mb-4" />
              <h4 className="font-bold text-lg mb-2">Templates & Systems</h4>
              <p className="text-gray-300 text-sm">Scripts, funnels, and proven systems</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div 
          className="includes-section bg-gradient-to-r from-blue-500/20 to-purple-500/20 p-8 rounded-2xl border border-blue-500/30"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h3 className="text-2xl font-bold text-center mb-8">What's Included</h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>Daily action steps for 7 days</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>Implementation support with Abdul's team</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>Access to templates, scripts, and funnels</span>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>Unlimited 1-to-1 calls within the month</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>Proven systems and frameworks</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>90-Day 1 Crore Game Plan</span>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-sm text-gray-300">
              * Unlimited calls are booked via calendar, but no limit on sessions within the mentorship month
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MentorshipSection;